export const BASE_URL = 'https://api.zoom.edunixsystem.com/';
// export const BASE_URL = 'https://api.alnukhbeh-edu.com/'
// export const BASE_URL = 'https://syria-flowers.beetronix.com/'

export const IMAGE_URL = 'https://api.zoom.edunixsystem.com/files/logo.png';

export const VERSION = '4.3.0';
